export const TARIFFS_QUERY_KEYS = {
  getTariffs: "get:/v1/payment/price",
  getPayHistory: "get:/v1/payment/history",
};
